import { useCallback, useMemo } from 'react';

import { useLocalStorageState } from '../use-local-storage-state/use-local-storage-state';

type Value<T> = T | undefined;

export const useLocalStorageValidState = <T>(
  localStorageKey: string,
  validate: (value: Value<T>) => Value<T>,
) => {
  const [value, setValue] = useLocalStorageState<Value<T>>(localStorageKey);

  const setLocalStorageValidState = useCallback(
    (value: Value<T>) => {
      const newValue = validate(value);

      setValue(newValue);
    },
    [setValue, validate],
  );

  const localStorageValidState = useMemo(
    () => validate(value),
    [value, validate],
  );

  return [localStorageValidState, setLocalStorageValidState] as [
    Value<T>,
    (value: Value<T>) => void,
  ];
};
